// extracted by mini-css-extract-plugin
export default {"tdcpWrapper":"cardPreviewModal_tdcpWrapper__7HaF+","introText":"cardPreviewModal_introText__UczGu","actionSection":"cardPreviewModal_actionSection__6ZV+n"};